import { getErrorMessage } from 'services/FionaAPI/templates/ClientFactory'

export class AlreadyExecutedError extends Error {
	constructor(message: string) {
		super(message)
	}
}

export const checkForAlreadyExecutedSearchError = async (response: Response): Promise<void> => {
	if (response.status === 400) {
		const message = await getErrorMessage(response)
		if (message === 'Search is already executed') {
			throw new AlreadyExecutedError(message)
		}
	}
}
